<script setup lang="ts">
  defineOptions({ name: 'EventCardSkeleton' })

  import { createElementId } from '@common/core-layer/utils'

  import CPSkeleton from '@ui/components/CPSkeleton.vue'

  defineProps({
    idPrefix: {
      type: String,
      default: 'event',
    },
    index: {
      type: Number,
      default: 1,
    },
  })
</script>

<template>
  <article
    :id="createElementId(idPrefix, 'skeleton-card', String(index))"
    class="event-card-skeleton flex w-full max-w-[25rem] flex-col overflow-hidden rounded-lg border border-solid border-[var(--cp-border-500)] bg-background"
    aria-hidden="true"
  >
    <div class="relative aspect-[2/1] w-full overflow-hidden rounded-t-lg">
      <CPSkeleton
        :id="createElementId(idPrefix, 'skeleton-cover', String(index))"
        type="image"
        width="100%"
        height="100%"
        :round="false"
        class="h-full w-full rounded-none"
      />
    </div>
    <div class="flex flex-1 flex-col gap-1.5 px-3 py-3">
      <CPSkeleton :id="createElementId(idPrefix, 'skeleton-title', String(index))" type="text" width="80%" height="1.25rem" />
      <CPSkeleton :id="createElementId(idPrefix, 'skeleton-date', String(index))" type="text" width="70%" height="1rem" />
      <CPSkeleton :id="createElementId(idPrefix, 'skeleton-place', String(index))" type="text" width="45%" height="1rem" />
    </div>
  </article>
</template>
